import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import '../../App.css';
import SectionHeader from './SectionHeader';
import useScrollAnimation from '../../hooks/useScrollAnimation';

import arrowIcon from '../../assets/images/arrow_icon.png'
import commentIcon from '../../assets/images/comment_icon.png'
import clockIcon from '../../assets/images/clock_icon.png'
import coinIcon from '../../assets/images/coin_icon.png'

const cardsData = [
  {
    title: 'Execution & Payments',
    text: 'A global fiat to crypto on/off ramp for both individual traders and businesses.',
    icon: <img src={arrowIcon} alt="Coin Icon"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "contain",
      }}
    />,
    badgePosition: 'top',
  },
  {
    title: 'Licensed & Regulated',
    text: 'As a licensed company, we ensure every transaction meets the highest global compliance standards.',
    icon: <img src={commentIcon} alt="Coin Icon"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "contain",
      }}
    />,
    badgePosition: 'bottom',
  },
  {
    title: 'Available 24/7',
    text: 'Our team operates around the clock. Always on, always available.',
    icon: <img src={clockIcon} alt="Coin Icon"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "contain",
      }}
    />,
    badgePosition: 'top',
  },
  {
    title: 'Liquidity & Support',
    text: 'High liquidity meets hands-on customer support. We combine institutional-grade security and execution with personalised service.',
    icon: <img src={coinIcon} alt="Coin Icon"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "contain",
      }}
    />,
    badgePosition: 'bottom',
  },
];

const DifferenceSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation(0.2);
  const [cardsRef, cardsVisible] = useScrollAnimation(0.1);

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 2, md: 5 },
        backgroundColor: '#0A080B',
        color: '#fff',
      }}
    >
      <Container maxWidth="lg">
        <Box
          ref={headerRef}
          className={`anim-fade-up${headerVisible ? ' in-view' : ''}`}
        >
          <SectionHeader
            title="The Payible Difference"
            titleClassName="diff-title"
            descriptionClassName="diff-desc"
            hideDivider={true}
          />
        </Box>

        {/* 4 Cards Grid */}
        <Grid container spacing={4} ref={cardsRef}>
          {cardsData.map((card, index) => {
            const isTopBadge = card.badgePosition === 'top';

            return (
              <Grid
                size={{ xs: 12, sm: 6, md: 3 }}
                key={index}
                className={`anim-fade-up anim-d${index}${cardsVisible ? ' in-view' : ''}`}
              >
                <Box
                  id={`difference-card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
                  className="card-hover-lift"
                  sx={{
                    backgroundColor: '#1C1C1F',
                    borderRadius: '20px',
                    p: 4,
                    minHeight: { xs: 'auto', sm: '360px' },
                    width: {
                      xs: '100%',
                      sm: '344px',
                      md: '220px',
                      lg: '264px',
                    },
                    mx: "auto",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    position: 'relative',
                    overflow: 'hidden',
                    alignItems: { xs: 'center', md: 'stretch' },
                    boxShadow: 'var(--fs-card-background-shadow)',
                  }}
                >
                  {/* Top Badge Rendering */}
                  {isTopBadge && (
                    <Box
                      className="card-badge"
                      sx={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(12, 18, 33, 0.4)',
                        border: '1px solid rgba(122, 212, 197, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 3,
                        transition: 'all 0.3s ease',
                        alignSelf: { xs: 'center', md: 'flex-start' },
                      }}
                    >
                      {card.icon}
                    </Box>
                  )}

                  {isTopBadge && <Box sx={{ flexGrow: 1 }} />}

                  {/* Text Contents */}
                  <Box sx={{ flexGrow: isTopBadge ? 0 : 1, textAlign: { xs: 'center', md: 'left' } }}>
                    <Typography
                      variant="h6"
                      className="diff-card-title"
                      sx={{
                        mb: 2,
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      className="diff-card-text"
                      sx={{
                        lineHeight: 1.6,
                      }}
                    >
                      {card.text}
                    </Typography>
                  </Box>

                  {/* Bottom Badge Rendering */}
                  {!isTopBadge && (
                    <Box
                      className="card-badge"
                      sx={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(12, 18, 33, 0.4)',
                        border: '1px solid rgba(122, 212, 197, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 4,
                        transition: 'all 0.3s ease',
                        alignSelf: { xs: 'center', md: 'flex-start' },
                      }}
                    >
                      {card.icon}
                    </Box>
                  )}
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default DifferenceSection;
